import {School} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import FlashCard from './FlashCard';

export const flashcard: FeatureObject = {
  type: 'feature',
  title: 'Flashcard Generator',
  description: 'Generate flashcards from CSV data',
  IconComponent: School,
  showFeatureFrontPage: true,
  path: '/flashcard',
  component: () => <FlashCard />,
  status: FeatureStatus.ADMIN,
  tags: ['flashcard', 'pdf', 'csv', 'education'],
};
